import { animated, config, useTransition } from "@react-spring/web";
import React, { FunctionComponent, useEffect, useRef, useState } from "react";

// Only renders children when expanded
export const VerticalExpandPanel: FunctionComponent<
  React.PropsWithChildren<{ isOpen?: boolean }>
> = ({ isOpen, children }) => {
  // If panel is initially mounted open, don't show enter transition
  const [initiallyOpen, setInitiallyOpen] = useState(isOpen);
  useEffect(() => {
    if (!isOpen) {
      setInitiallyOpen(false);
    }
  }, [isOpen]);

  const ref = useRef<HTMLDivElement>(null);
  const transitions = useTransition(isOpen, {
    from: initiallyOpen
      ? { height: ref.current?.offsetHeight, opacity: 1 }
      : { height: 0, opacity: 0 },
    enter: () => async (next) => {
      await next({ height: ref.current?.offsetHeight, opacity: 1 });
      // // Set to auto after animating so that element adjusts when children update/animate
      await next({ height: "auto" });
    },
    leave: () => async (next) => {
      await next({ height: 0, opacity: 0 });
    },
    config: { ...config.stiff, clamp: true },
  });

  return transitions(
    (props, item) =>
      item && (
        <animated.div style={props} className="overflow-hidden">
          <div ref={ref}>{children}</div>
        </animated.div>
      )
  );
};
